import { useEffect, useState } from 'react';

const getMatches = (query) => {
    if (typeof window === 'undefined' || !window.matchMedia) {
        return false;
    }

    return window.matchMedia(query).matches;
};

const useIsSmallScreen = (query = '(max-width: 991.98px)') => {
    const [isSmallScreen, setIsSmallScreen] = useState(() => getMatches(query));

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return undefined;
        }

        const mediaQuery = window.matchMedia(query);
        const handleChange = (event) => setIsSmallScreen(event.matches);

        setIsSmallScreen(mediaQuery.matches);

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handleChange);
            return () => mediaQuery.removeEventListener('change', handleChange);
        }

        mediaQuery.addListener(handleChange);
        return () => mediaQuery.removeListener(handleChange);
    }, [query]);

    return isSmallScreen;
};

export default useIsSmallScreen;
